export default __webpack_public_path__ + "static/media/email.c9a925a5.svg";